import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Launch from "./pages/Launch";
import Services from "./pages/Services";
import WebDevelopment from "./pages/services/WebDevelopment";
import CustomSoftware from "./pages/services/CustomSoftware";
import AIAutomation from "./pages/services/AIAutomation";
import GrowthMarketing from "./pages/services/GrowthMarketing";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Consultation from "./pages/Consultation";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {
  return (
    <div>
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#121212',
            color: '#FDFCF8',
            border: '1px solid #2a2a2a'
          }
        }}
      />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/launch" element={<Launch />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/custom-software" element={<CustomSoftware />} />
          <Route path="/services/ai-automation" element={<AIAutomation />} />
          <Route path="/services/growth-marketing" element={<GrowthMarketing />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
